import useSWR from "swr";

import { CONFIG_UPDATE_INTERVAL } from "lib/timeConstants";

import { fetchLeaderboard } from "./requests";
import { FetchLeaderboardParams, LeaderboardApiResponse } from "./types";

export function useGetLeaderboard(chainId: number, params: FetchLeaderboardParams, enabled = true) {
  return useSWR<LeaderboardApiResponse>(
    enabled ? ["leaderboard", chainId, JSON.stringify(params)] : null,
    () => fetchLeaderboard(chainId, params),
    {
      refreshInterval: CONFIG_UPDATE_INTERVAL,
    }
  );
}
